<h2 mat-dialog-title class="title">
  <mat-icon>warning</mat-icon>
  <label>{{ 'commonTerminateConfirmDialog.warning' | translate }}</label>
</h2>
<div fxLayout="column" fxLayoutAlign="center center">
  <p class="message">
    {{firstMessage}}<br>
    {{secondMessage}}<br>
    {{thirdMessage}}
  </p>
  <mat-form-field style="width: 100%; margin-top: 10px;">
    <mat-label>{{ 'commonTerminateConfirmDialog.confirmation' | translate }}</mat-label>
    <input matInput [(ngModel)]="confirmInput" name="confirmInput">
    <mat-hint *ngIf="isDisableTerminate()" align="start">
      <font>{{'commonTerminateConfirmDialog.explanation' | translate}}</font>
    </mat-hint>
  </mat-form-field>
</div>
<div class="container" fxLayout="row" fxLayoutAlign="center center" position="fixed">
  <mat-dialog-actions>
    <button mat-button color="primary" [mat-dialog-close]="false">{{ 'commonTerminateConfirmDialog.cancel' | translate }}</button>
    <button mat-raised-button color="warn" [mat-dialog-close]="true" [disabled]="isDisableTerminate()">
      {{ 'commonTerminateConfirmDialog.initialize' | translate }}
    </button>
  </mat-dialog-actions>
</div>